import { Badge, Box } from '@mui/material';
import React from 'react';

export enum BadgeType {
  DEFAULT = 'default',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SUCCESS = 'success',
}

type NotificationBadgeProps = {
  color: BadgeType;
  count: number | undefined;
  children: React.ReactNode;
};

const NotificationBadge: React.FC<NotificationBadgeProps> = ({ color, count, children }) => {
  return (
    <Badge
      sx={{}}
      slotProps={{
        badge: {
          sx: {
            padding: '.35rem',
            right: '-.35rem',
            top: '-.35rem',
          },
        },
      }}
      color={color}
      badgeContent={count}
      anchorOrigin={{ horizontal: 'right', vertical: 'top' }}>
      <Box pr={count ? 2 : 0}>{children}</Box>
    </Badge>
  );
};

export default React.memo(NotificationBadge);
